<template>
    <div v-if="model.file_path">
        <iframe v-if="model.file_path.split('.').pop() == 'pdf'" width="100%" style="height: 100vh" :src="model.file_path+ '#toolbar=0&navpanes=0'"></iframe><img v-else :src="model.file_path" class="img-fluid"/>
    </div>
  </template>
  
  <script>
  import SchoolFileAsset from "@/models/SchoolFileAsset.js";
  
  const model = new SchoolFileAsset();
  
  export default {
    watch: {
      "$route.params.id": function (val) {
        if (val !== undefined) {
          this.getDetail();
        }
      },
    },
    data() {
      return {
        model: {
          id: null,
          file_description: null,
          file_path: null,
          tag: null,
        },
        isLoading: false,
      };
    },
    mounted() {
      this.getDetail();
    },
    methods: {
      getDetail() {
        this.isLoading = true;
        model
          .find(this.$route.params.id).then((resp) => {
            this.isLoading = false;
            this.model = resp
          }).catch((error) => {
            if (process.env.NODE_ENV !== "production") {
              console.error(error);
            }
            this.$store.dispatch("notification/error", error);
            this.isLoading = false;
          });
      },
    },
  };
  </script>